import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { RouteElements } from '@/routes'
import './App.css'

function App() {
  return (
    <BrowserRouter>
      <RouteElements />
    </BrowserRouter>
  )}

export default App
